import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
// import Done from 'material-ui/svg-icons/action/done';
import InputField from '../framework/InputField/InputField';
import Dropzone from 'react-dropzone';
import Tooltip from 'rc-tooltip';
import TipIcon from 'material-ui/svg-icons/action/info-outline';
import Done from 'material-ui/svg-icons/action/done';
// import Dialog from 'material-ui/Dialog';
import Error from 'material-ui/svg-icons/alert/error';
// button color
import {buttonBlueColor} from '../../utils/utility';
import Select from 'react-select';

import './create-account.css';

class CreateAccount extends Component {
  constructor(props) {
    super(props);
    this.flag = true;
    this.flagBase = true;
    this.flagPhoto = true;
    this.state = {
      ifHiddenTopEdit: false, // if show top form edit
      ifHiddenBottomEdit: true,
      requiredFirstNameText: '', // requied field firset name tip text
      requiredLastNameText: '', // required field last name tip text
      requiredEmailText: '', // required field email tip text
      ifLogoUploadButtonEnable: false, // if upload button enable for logo
      ifPhotoUploadButtonEnable: false, // if uploda button enable for photo
      logoFileName: 'No file chosen',
      photoFileName: 'No file chosen',
      roleValue: '',
      stateValue: '',
      timezoneValue: '',
      departmentValue: '',
      clientId: '', // client id for upload
      companyLogoErrorText: '',
      profilePhotoErrorText: '',
      companyLogoUuid: '', // logo uuid
      userAvatarUuid: '',
      roleInfo: '', //store role object information
      requestParams: {
        username: '',
        password: '',
        confirmPassword: '',
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        departmentId: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        timezone: '',
        officePhone: '',
        mobilePhone: '',
        companyLogoUuid:''
      },
      imgDataBase64:'', // for company logo
      // password_error_tip_show: false,
      newLogoBase64: '',
      newPhotoBase64: '',
      showNewPwError: false,
      showConfirmPwError: false
    }
  }
  componentDidMount() {
    this.props.getInvitationByCode(this.props.match.params.id);
    localStorage.setItem('newPhotoBase64', '');
    this.props.logout();
  }
  componentWillReceiveProps(nextProps) {
    // change blob to base64 for photo
    if (nextProps.get_invitation_by_code.invitation) {
      const {
        firstName,
        lastName,
        email,
        role,
        id,
      } = nextProps.get_invitation_by_code.invitation;
      this.setState({
        clientId: id
      })
      // implement one time.
      // if (this.flag) {
      //   this.props.getCompanyLogo(nextProps.loginUserDetail.client.id); // get logo img
      //   //this.props.getUserAvatar(nextProps.loginUserDetail.avatar); // get photo img
      //   this.flag = false;
      // }

      this.setState({
        // roleValue: role.id,
        // stateValue: state,
        roleInfo: role,
        requestParams: {
          ...this.state.requestParams,
          firstName,
          lastName,
          email
        }
      })
    }
  }
  handleItemsChange (e, index, value) {
    this.setState({
      roleValue: value
    })
  }
  handleDepartmentChange (value) {
    this.setState({
      departmentValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        departmentId: value.value
      }
    })
  }
  handleStateChange (value) {
    this.setState({
      stateValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        state: value.value
      }

    })
  }
  handleTimeZoneChange (value) {
    this.setState({
      timezoneValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        timezone: value.value
      }
    })
  }

  handleTitle (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        title: value
      }
    });
  }
  handleFirstName (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        firstName: value
      }
    })
  }
  handleLastName (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        lastName: value
      }
    })
  }
  handleEmail (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value
      }
    })
  }
  handleUsername (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        username: value
      }
    })
  }
  handleCompanyAdd1 (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address1: value
      }
    })
  }
  handleCompanyAdd2 (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address2: value
      }
    })
  }
  handleCity (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        city: value
      }
    })
  }
  handleZipCode (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        zipCode: value
      }
    })
  }
  handleOfficePhoneNumber (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        officePhone: value
      }
    })
  }
  handleMobilePhoneNumber (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        mobilePhone: value
      }
    })
  }
  handleCompanyName (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        companyName: value
      }
    })
  }
  handleDrop (files, accept, reject) {
    this.setState({
      logoFileName: files[0],
      ifLogoUploadButtonEnable: true,
      companyLogoErrorText: ''
    })
  }
  handleDropProfile (files, accept, reject) {
    this.setState({
      photoFileName: files[0],
      ifPhotoUploadButtonEnable: true,
      profilePhotoErrorText: ''
    })
  }
  onDropRejected () {
    this.setState({
      companyLogoErrorText: 'Only jpg, png, and gif file with maximum size of 1MB is allowed'
    });
  }
  onDropProfileRejected () {
    this.setState({
      profilePhotoErrorText: 'Only jpg, png, and gif file with maximum size of 1MB is allowed'
    });
  }
  handleUpdateProfile () {
    if (this.state.requestParams.firstName.trim().length === 0) {
      this.setState({
        requiredFirstNameText: 'Please enter your first name'
      })
    } else {
      this.setState({
        requiredFirstNameText: ''
      })
    }
    if (this.state.requestParams.lastName.trim().length === 0) {
      this.setState({
        requiredLastNameText: 'Please enter your last name'
      })
    } else {
      this.setState({
        requiredLastNameText: ''
      })
    }
    if (this.state.requestParams.email.trim().length === 0) {
      this.setState({
        requiredEmailText: 'Please enter your email'
      })
    } else {
      this.setState({
        requiredEmailText: ''
      })
    }
    if (this.state.requestParams.firstName.trim().length > 0 && this.state.requestParams.lastName.trim().length > 0 && this.state.requestParams.email.trim().length > 0) {
      this.props.register(this.props.match.params.id, this.state.requestParams);
    }
  }
  handleCloseDialog () {
    // reload redux
    this.props.setStatus(false);
    this.props.getCurrentUserProfile(); // request my profile again
    this.flag = true;
    this.flagBase = true;
    this.flagPhoto = true;
    this.setState({
      ifHiddenTopEdit: false, // if show top form edit
      ifHiddenBottomEdit: true,
      requiredFirstNameText: '',
      requiredLastNameText: '',
      requiredEmailText: '',
      ifLogoUploadButtonEnable: false,
      ifPhotoUploadButtonEnable: false,
      logoFileName: 'No file chosen',
      photoFileName: 'No file chosen',
      roleValue: '',
      stateValue: '',
      timezoneValue: '',
      departmentValue: '',
      clientId: '', // client id for upload
      companyLogoErrorText: '',
      profilePhotoErrorText: '',
      companyLogoUuid: '', // logo uuid
      userAvatarUuid: '', // avatar uuid
      requestParams: {
        username: '',
        password: '',
        confirmPassword: '',
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        departmentId: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        timezone: '',
        officePhone: '',
        mobilePhone: '',
        companyLogoUuid:'',
      },
      imgDataBase64:'', // for company logo
      newLogoBase64: '',
      newPhotoBase64: ''
    })
  }
  handlePhotoLogo () {
    if (this.state.ifPhotoUploadButtonEnable) {
      let formData = new FormData();
      formData.append('avatar', this.state.photoFileName);
      // call api
      fetch(`/api/avatars/${this.props.match.params.id}/upload`, {
        method: 'POST',
        body: formData
      })
        .then(
          (res) => {
            if (res.status === 200) {
              this.setState({
                profilePhotoErrorText: '',
                newPhotoBase64: this.state.photoFileName.preview,
                requestParams: {
                  ...this.state.requestParams,
                  avatar: this.state.photoFileName.name
                }
              })
            } else {
              res.json().then((json) => {
                this.setState({
                  profilePhotoErrorText: json.message
                })
              })
            }
          },
          () => {

          }
        )
        .catch((err) => {
          alert(err);
        })
    }

  }
  handleUploadLogo () {
    if (this.state.ifLogoUploadButtonEnable) {
      let formData = new FormData();
      formData.append('logo', this.state.logoFileName);
      // call api
      fetch(`/api/invitations/with/${this.props.match.params.id}/logo/upload`, {
        method: 'POST',
        body: formData
        // headers: new Headers({
        //   'Authorization': this.props.token
        // })
      })
        .then(
          (res) => {
            if (res.status === 200) {
              return res.json();
            } else {
              res.json().then((json) => {
                this.setState({
                  companyLogoErrorText: json.message
                })
              })
            }
          },
          () => {

          }
        )
        .then((json) => {
          if(typeof json !== 'undefined') {
            this.setState({
              companyLogoErrorText: '',
              requestParams: {
                ...this.state.requestParams,
                companyLogoUuid: json.uuid
              },
              newLogoBase64: this.state.logoFileName.preview
            })
          }
        })
        .catch((err) => {
          alert(err);
        })
    }
  }
  handleNewPassword (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        password: value
      },
      showNewPwError: false
    });
  }
  handleConfirmPassword (e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        confirmPassword: value
      },
      showConfirmPwError: false
    });
  }
  _pwdInputKeyDown(e) {
    if (e.keyCode === 32)
      e.preventDefault();
  }
  render () {
    const muiTheme = getMuiTheme({
      menuItem: {
        hoverColor: buttonBlueColor()
      },
    });
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="profile" style={{marginTop: '2em'}}>
          {
            this.props.invitation_error_message !== '' && (
              <p style={{fontSize: '16px', color: 'black', fontWeight: 'bolder', padding: '25px 0', textAlign: 'center'}}>{this.props.invitation_error_message}</p>
            )
          }

          {(!this.props.ifRequestSuccess && this.props.invitation_error_message === '') && (
            <div className="profile-wrapper" style={{minWidth: '568px'}}>
              <div className="profile-form-top">
                <h1 style={{border: 'none', marginTop: '0.5em', marginBottom: '0.5em'}}>MY PROFILE</h1>
                <div className="role-intro clearfix" style={{border: !this.state.ifHiddenTopEdit ? 'none' : '', marginBottom: '17px'}}>
                  <span>Role</span>
                  <small>{this.state.roleInfo.name}</small>
                  <Tooltip
                    placement="right"
                    overlayClassName="profile-role-info"
                    overlayStyle={{width:"36%"}}
                    overlay={
                      <div className="profile-overlay-container">
                        <p>{this.state.roleInfo.name}</p>
                        <ul>
                          {
                            this.state.roleInfo !== '' && this.state.roleInfo.capabilities.map((item, index) => (
                              <li className="clearfix" key={index}>
                                <div className="icon" style={{background: buttonBlueColor()}}>
                                  <Done
                                    style={{width: '14px', height: '14px', color: 'white'}}
                                  />
                                </div>
                                <section>
                                  {item}
                                </section>
                              </li>
                            ))
                          }

                        </ul>
                      </div>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                    <TipIcon
                      style={{color: 'black', width: '25px', height: '25px', marginTop: '9px', marginLeft: '10px', cursor: 'pointer'}}
                    />
                  </Tooltip>
                </div>
                <div className="profile-form">
                  <div className="top">
                    <InputField
                      labelTitle="Title"
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      onChange={(e, value) => this.handleTitle(e, value)}
                      inputContainerId="companyAddress1"
                      borderColor="black"
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                    />
                    <div className="profile-fn-wrapper" style={{marginTop: '1.5em'}}>
                      <InputField
                        labelTitle="First Name"
                        ifRequireField={true}
                        onChange={(e, value) => this.handleFirstName(e, value)}
                        ifHasBorder={this.state.ifHiddenTopEdit}
                        initValue={this.state.requestParams.firstName}
                        borderColor="black"
                        labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                        inputContainerId="firstName"
                        style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}

                      />
                      {
                        this.state.requiredFirstNameText && (
                          <p className="create-account-field-error clearfix">
                            <Error
                              style={{float: 'left'}}
                              color="red"
                            />
                            <span>{this.state.requiredFirstNameText}</span>
                          </p>
                        )
                      }
                    </div>
                    <div className="profile-fn-wrapper" style={{marginTop: '1.5em'}}>
                      <InputField
                        labelTitle="Last Name"
                        ifRequireField={true}
                        onChange={(e, value) => this.handleLastName(e, value)}
                        ifHasBorder={this.state.ifHiddenTopEdit}
                        initValue={this.state.requestParams.lastName}
                        borderColor="black"
                        labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                        inputContainerId="firstName"
                        style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}

                      />
                      {
                        this.state.requiredLastNameText && (
                          <p className="create-account-field-error clearfix">
                            <Error
                              style={{float: 'left'}}
                              color="red"
                            />
                            <span>{this.state.requiredLastNameText}</span>
                          </p>
                        )
                      }
                    </div>
                    <div className="profile-email-wrapper">
                      <InputField
                        labelTitle="E-mail Address"
                        ifRequireField={true}
                        ifHasBorder={this.state.ifHiddenTopEdit}
                        labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                        onChange={(e, value) => this.handleEmail(e, value)}
                        initValue={this.state.requestParams.email}
                        inputContainerId="emailAddress"
                        borderColor="black"
                        style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                      />
                      {
                        this.state.requiredEmailText && (
                          <p className="create-account-field-error clearfix">
                            <Error
                              style={{float: 'left'}}
                              color="red"
                            />
                            <span>{this.state.requiredEmailText}</span>
                          </p>
                        )
                      }
                    </div>
                    <div className="profile-username">
                      {/*<div className="top-shadow" style={{display: this.state.ifHiddenTopEdit ? 'block' : 'none'}}></div>*/}
                      <InputField
                        labelTitle="Username"
                        labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                        ifHasBorder={this.state.ifHiddenTopEdit}
                        onChange={(e, value) => this.handleUsername(e, value)}
                        inputContainerId="username"
                        borderColor="black"
                        style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                      />
                    </div>
                    <div className="role clearfix" style={{lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}>
                      <p style={{color: 'black', fontSize: '14px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder'}}>Department</p>
                      <Select
                          className="cp-dropdown "
                          value={this.state.departmentValue}
                          clearable={false}
                          options={this.props.get_invitation_by_code.departments}
                          onChange={(value) => this.handleDepartmentChange(value)}
                        />
                    </div>
                    <InputField
                      labelTitle="Mobile Phone Number"
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      onChange={(e, value) => this.handleMobilePhoneNumber(e, value)}
                      inputContainerId="mobileNumber"
                      borderColor="black"
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                    />
                    <InputField
                      labelTitle="Office Phone Number"
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      onChange={(e, value) => this.handleOfficePhoneNumber(e, value)}
                      inputContainerId="officeNumber"
                      borderColor="black"
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                    />
                    <InputField
                      labelTitle="Company Name"
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      onChange={(e, value) => this.handleCompanyName(e, value)}
                      inputContainerId="officeNumber"
                      borderColor="black"
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                    />
                    <InputField
                      labelTitle="Company Address 1"
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      onChange={(e, value) => this.handleCompanyAdd1(e, value)}
                      inputContainerId="companyAddress1"
                      borderColor="black"
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                    />
                    <InputField
                      labelTitle="Company Address 2"
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      onChange={(e, value) => this.handleCompanyAdd2(e, value)}
                      inputContainerId="companyAddress1"
                      borderColor="black"
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                    />
                    <InputField
                      labelTitle="City"
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      onChange={(e, value) => this.handleCity(e, value)}
                      inputContainerId="city"
                      borderColor="black"
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                    />
                    <div className="role clearfix" style={{lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}>
                      <p style={{color: 'black', fontSize: '14px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder'}}>State</p>
                        <Select
                          className="cp-dropdown state-dropdown"
                          value={this.state.stateValue}
                          clearable={false}
                          options={this.props.get_invitation_by_code.states}
                          onChange={(value) => this.handleStateChange(value)}
                        />
                    </div>
                    <InputField
                      labelTitle="Zip Code"
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      onChange={(e, value) => this.handleZipCode(e, value)}
                      inputContainerId="zipCode"
                      borderColor="black"
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}
                    />
                    <div className="role clearfix" style={{lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenTopEdit ? '30px': 0}}>
                      <p style={{color: 'black', fontSize: '14px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder'}}>Time Zone <em style={{color: 'red'}}>*</em></p>
                        <Select
                          className="cp-dropdown "
                          value={this.state.timezoneValue}
                          clearable={false}
                          options={this.props.get_invitation_by_code.timezones}
                          onChange={(value) => this.handleTimeZoneChange(value)}
                        />
                    </div>
                  </div>
                </div>
              </div>
              <div className="profile-logo-wrapper">
                {
                  /^system Administrator|admin/gi.test(this.state.roleInfo.name) && (
                    <div className="profile-logo profile-company-logo clearfix">
                      <div className="clearfix">
                        <div className="title clearfix">
                    <span id="profile-subtit">
                      Logo
                    </span>
                        </div>
                        <div className="review">
                          <div className="profile-edit-img">
                            <section className="section">Select a logo to upload</section>
                            <Dropzone
                              onDrop={(files, accept, reject) => this.handleDrop(files, accept, reject)}
                              style={{width: '100%'}}
                              accept="image/jpeg, image/png, image/jpg, image/gif"
                              maxSize={1048576}
                              onDropRejected={() => this.onDropRejected()}
                              name="logo"
                            >
                              <p style={{textAlign: 'center', display: 'inline-block', width: '20%', height: '20px', fontSize: '12px', border: '1px solid grey', color: 'black', borderRadius: '6px', lineHeight: '20px', marginTop: '10px'}}>Choose File</p>
                              <i style={{fontStyle: 'normal', marginLeft: '6px'}}>{(this.state.logoFileName !== undefined && this.state.logoFileName.name) || 'No file chosen'}</i>
                              <section className="spec">
                                (Only jpg, png, and gif file with maximum size of 1MB is allowed)
                              </section>
                            </Dropzone>
                            <img src={this.state.newLogoBase64} alt=""/>
                            <button style={{background: buttonBlueColor()}} onClick={() => this.handleUploadLogo()}>UPLOAD LOGO</button>
                          </div>
                        </div>
                      </div>
                      <div className="error" style={{bottom: '10px'}}>{this.state.companyLogoErrorText}</div>
                    </div>
                  )
                }

                <div className="profile-logo profile-photo clearfix">
                  <div className="clearfix">
                    <div className="title clearfix">
                    <span id="profile-subtit">
                      Profile Photo
                    </span>
                    </div>
                    <div className="review">
                      <div className="profile-edit-img">
                        <section className="section">Select a photo to upload</section>
                        <Dropzone
                          onDrop={(files, accept, reject) => this.handleDropProfile(files, accept, reject)}
                          style={{width: '100%'}}
                          accept="image/jpeg, image/png, image/jpg, image/gif"
                          maxSize={1048576}
                          onDropRejected={() => this.onDropProfileRejected()}
                          name="avatar"
                        >
                          <p style={{textAlign: 'center', display: 'inline-block', width: '20%', height: '20px', fontSize: '12px', border: '1px solid grey', color: 'black', borderRadius: '6px', lineHeight: '20px', marginTop: '10px'}}>Choose File</p>
                          <i style={{fontStyle: 'normal', marginLeft: '6px'}}>{(this.state.photoFileName !== undefined && this.state.photoFileName.name) || 'No file chosen'}</i>
                          <section className="spec">
                            (Only jpg, png, and gif file with maximum size of 1MB is allowed)
                          </section>
                        </Dropzone>

                        <img src={this.state.newPhotoBase64} alt=""/>
                        <button style={{background: buttonBlueColor()}} onClick={() => this.handlePhotoLogo()}>UPLOAD PHOTO</button>
                      </div>

                    </div>
                  </div>
                  <div className="error" style={{bottom: '10px'}}>{this.props.update_photo_msg || this.state.profilePhotoErrorText}</div>
                </div>
              </div>
              <div className="profile-change-pw" style={{minWidth: '568px'}}>
                <h1 style={{border: this.state.ifHiddenChangePw ? '' : 'none'}}>CREATE YOUR PASSWORD</h1>
                <p className="tip" style={{display: this.state.ifHiddenChangePw ? 'none' : 'block'}}>
                  Enter a combination of at least 6 numbers, letters, and special characters
                </p>

                <div className="profile-username">
                  {
                    this.state.showNewPwError && (
                      <p className="profile-fn-error">
                        {this.props.change_password_error_msg}
                      </p>
                    )
                  }
                  <div className="profile-fn-wrapper">
                    <InputField
                      labelTitle={this.state.ifHiddenChangePw ? 'Password' : 'New Password'}
                      ifHasBorder={this.state.ifHiddenChangePw}
                      inputType="password"
                      ifRequireField={true}
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      inputContainerId="change-password"
                      borderColor="black"
                      onKeyDown={this._pwdInputKeyDown}
                      onChange={(e, value) => this.handleNewPassword(e, value)}
                      style={{height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenChangePw ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenChangePw ? '49px': 0}}
                    />
                  </div>
                  <div className="profile-fn-wrapper">
                    <InputField
                      labelTitle={'Confirm Password'}
                      ifHasBorder={this.state.ifHiddenChangePw}
                      inputType="password"
                      ifRequireField={true}
                      onKeyDown={this._pwdInputKeyDown}
                      labelStyle={{float:'left', fontSize: '14px', fontWeight: 'bolder', width: '30%', margin: 0}}
                      inputContainerId="change-password"
                      borderColor="black"
                      onChange={(e, value) => this.handleConfirmPassword(e, value)}
                      style={{display: this.state.ifHiddenChangePw ? 'none' : 'block', height: '32px', lineHeight: '32px', borderBottom: this.state.ifHiddenChangePw ? '2px solid grey' : '', marginBottom: !this.state.ifHiddenChangePw ? '40px': 0}}
                    />
                  </div>
                </div>
              </div>
              <div className="profile-edit clearfix">
                <div className="save-group clearfix">
                  <button className="save" style={{background: buttonBlueColor()}} onClick={() => this.handleUpdateProfile()}>SAVE</button>
                </div>
                <p style={{float: 'left', color: 'red', lineHeight: '30px', marginTop:'1em'}}>{this.props.error}</p>
              </div>
            </div>
          )}
          {
            this.props.ifRequestSuccess && (
              <div className="create-account-success">
                <p>Your have successfully created your profile</p>
                <div className="btn-wrapper">
                  <a href="/login">LOGIN</a>
                </div>
              </div>
            )
          }
        </div>
      </MuiThemeProvider>
    )
  }
}

export default CreateAccount;


// WEBPACK FOOTER //
// ./src/components/CreateAccount/Index.jsx